// extracted by mini-css-extract-plugin
export var container = "_hh-1";
export var editor = "_hh-2";
export var resizable = "_hh-3";
export var wrapper = "_hh-0";